import React, { useState } from 'react';
import screenSearch from '../assets/screen-search.png';
import screenBooking from '../assets/screen-booking.png';

function Features() {
  const [activeTab, setActiveTab] = useState('top');

  const topFeatures = {
    image: screenSearch,
    left: [
      { id: 1, title: 'Telemedicine', desc: 'Connect with doctors through voice or video calls from the comfort of your home.', icon: 'bi-camera-video' },
      { id: 2, title: 'Track Ongoing', desc: 'Conveniently track your ongoing clinic tokens and queue status in real-time.', icon: 'bi-ticket-detailed' },
      { id: 3, title: 'Digital Records', desc: 'Receive and manage prescriptions digitally with automatic notifications.', icon: 'bi-file-medical' }
    ],
    right: [
      { id: 4, title: 'Quick Booking', desc: 'Fast and seamless doctor appointments scheduled in just a few taps.', icon: 'bi-calendar-check' },
      { id: 5, title: 'Lab Tests', desc: 'Find and book essential laboratory tests securely through the app.', icon: 'bi-droplet' },
      { id: 6, title: 'Patient Reviews', desc: 'Read authentic patient ratings and reviews to make informed decisions.', icon: 'bi-chat-quote' }
    ]
  };

  const smartFeatures = {
    image: screenBooking,
    left: [
      { id: 1, title: 'Smart Filters', desc: 'Narrow down search dynamically by location, specialty, and experience factor.', icon: 'bi-funnel' },
      { id: 2, title: 'Appointment Tracking', desc: 'Track pending, upcoming, and cancelled appointment statuses effortlessly.', icon: 'bi-journal-check' },
      { id: 3, title: 'Notification Alerts', desc: 'Keep track of payments, upcoming visits, and health alerts seamlessly.', icon: 'bi-bell' }
    ],
    right: [
      { id: 4, title: 'Flexible Slots', desc: 'Doctors manage specific interval or evening timing blocks intelligently.', icon: 'bi-clock' },
      { id: 5, title: 'Dynamic Dashboard', desc: 'View all upcoming updates and access quick services from your home screen.', icon: 'bi-house' },
      { id: 6, title: '24/7 Support', desc: 'Get assistance anytime with our dedicated support team for patients.', icon: 'bi-headset' }
    ]
  };

  const currentFeatures = activeTab === 'top' ? topFeatures : smartFeatures;

  return (
    <section className="section-padding features-section" id="features">
      .
      <div className=" container-lg">
        <h6 className="text-center text-primary-custom fw-semibold mb-2">MULTIPLE FEATURES</h6>
        <h2 className="section-title">Healthcare Made Simple</h2>
        <p className="text-center mb-4 text-muted">
          Discover how FastInQueue transforms the healthcare experience for both patients and doctors with our innovative features.
        </p>

        <div className="feature-toggle">
          <button
            className={`btn-toggle ${activeTab === 'top' ? 'active' : ''}`}
            onClick={() => setActiveTab('top')}
          >
            Top Features
          </button>
          <button
            className={`btn-toggle ${activeTab === 'smart' ? 'active' : ''}`}
            onClick={() => setActiveTab('smart')}
          >
            Smart Features
          </button>
        </div>

        <div className="row align-items-center mt-5">
          {/* Left List */}
          <div className="col-lg-4 order-2 order-lg-1">
            {currentFeatures.left.map((feature, index) => (
              <div className={`feature-item feature-item-left ${index === 2 ? 'mb-lg-0' : ''}`} key={feature.id}>
                <div className="feature-icon-wrapper">
                  <i className={`bi ${feature.icon}`}></i>
                </div>
                <h5>{feature.title}</h5>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>

          {/* Center Mobile App Screenshot with iPhone Mockup CSS */}
          <div className="col-lg-4 order-1 order-lg-2 text-center mb-5 mb-lg-0">
            <div className="iphone-mockup mx-auto" style={{ transform: 'scale(1)', zIndex: 10 }}>
              <div className="iphone-screen">
                <div className="iphone-notch"></div>
                <img
                  key={currentFeatures.image}
                  src={currentFeatures.image}
                  alt={`${activeTab} Features Mockup`}
                  className="w-100 h-100 object-fit-cover fade-in"
                />
              </div>
            </div>
          </div>

          {/* Right List */}
          <div className="col-lg-4 order-3 order-lg-3">
            {currentFeatures.right.map((feature, index) => (
              <div className={`feature-item feature-item-right ${index === 2 ? 'mb-0' : ''}`} key={feature.id}>
                <div className="feature-icon-wrapper">
                  <i className={`bi ${feature.icon}`}></i>
                </div>
                <h5>{feature.title}</h5>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
